import React, {Component} from 'react';
import clorianLogo from '../resources/images/Clorian.svg';
import {Overlay} from 'clorian-frontend-components';
import {connect} from "react-redux";
import {injectIntl} from 'react-intl';

class AppUserRegister extends Component {

  constructor(props) {
    super(props);
    this.state = {
      passwordError: '',
      firstNameError: '',
      lastNameError: '',
      isPasswordValid: false,
      passwordTouched: false
    };
    this.passwordValidationTimeout = null;
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validatePassword = this.validatePassword.bind(this);
    this.validateName = this.validateName.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handlePasswordFocus = this.handlePasswordFocus.bind(this);
    this.handleFirstNameChange = this.handleFirstNameChange.bind(this);
    this.handleLastNameChange = this.handleLastNameChange.bind(this);
  }

  componentWillUnmount() {
    if (this.passwordValidationTimeout) {
      clearTimeout(this.passwordValidationTimeout);
    }
  }

  validatePassword(password) {
    const {intl} = this.props;
  
    const passwordRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^*\-.])[A-Za-z0-9#?!@$%^*\-.]{8,16}$/;
    
    if (!passwordRegex.test(password)) {
      return intl.formatMessage({
        id: "register.error.password.validation",
        defaultMessage: "Length between 8 and 16, presence of at least one capital letter, one lower case letter, one digit and one special character in (#?!@$%^*-.)."
      });
    }
    
    return '';
  }

  validateName(name, fieldName) {
    const {intl} = this.props;
    
    // Solo permite letras (con acentos), espacios, guiones y apóstrofes
    const nameRegex = /^[a-zA-ZÀ-ÿ\u00f1\u00d1\s'-]+$/;

    
    if (!nameRegex.test(name)) {
      return intl.formatMessage({
        id: `register.error.${fieldName}.validation`,
        defaultMessage: `${fieldName === 'firstName' ? 'First name' : 'Last name'} can only contain letters, spaces, hyphens, and apostrophes.`
      });
    }
    
    return '';
  }

  handlePasswordFocus() {
    this.setState({ passwordTouched: true });
  }

  handlePasswordChange() {
    const password = this.pass.value;
    const passwordRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^*\-.])[A-Za-z0-9#?!@$%^*\-.]{8,16}$/;
    const isValid = passwordRegex.test(password);
    
    // Limpiar timeout anterior si existe
    if (this.passwordValidationTimeout) {
      clearTimeout(this.passwordValidationTimeout);
      this.passwordValidationTimeout = null;
    }
    
    // Si la contraseña es válida, limpiar el error inmediatamente
    if (isValid) {
      this.setState({ 
        passwordError: '',
        isPasswordValid: true
      });
    } else {
      // Si no es válida y el campo ha sido tocado, establecer timeout de 2 segundos
      this.setState({ 
        isPasswordValid: false
      });
      
      if (this.state.passwordTouched && password.length > 0) {
        this.passwordValidationTimeout = setTimeout(() => {
          const errorMessage = this.validatePassword(password);
          this.setState({ passwordError: errorMessage });
        }, 1000);
      }
    }
  }

  handleFirstNameChange() {
    if (this.state.firstNameError) {
      this.setState({ firstNameError: '' });
    }
  }

  handleLastNameChange() {
    if (this.state.lastNameError) {
      this.setState({ lastNameError: '' });
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    const {onSubmit} = this.props;

    const password = this.pass.value;
    const firstName = this.firstName.value;
    const lastName = this.lastName.value;

    // Validar todos los campos
    const passwordError = this.validatePassword(password);
    const firstNameError = this.validateName(firstName, 'firstName');
    const lastNameError = this.validateName(lastName, 'lastName');

    // Si hay algún error, mostrarlos y prevenir el envío
    if (passwordError || firstNameError || lastNameError) {
      this.setState({
        passwordError,
        firstNameError,
        lastNameError
      });
      return;
    }

    // Si todo está válido, proceder con el registro
    let formDetails = {
      username: this.user.value,
      password: password,
      firstName: firstName,
      lastName: lastName
    };

    onSubmit(formDetails);
  }


  render() {

    const {isRegistering, error} = this.props;
    const {passwordError, firstNameError, lastNameError} = this.state;

    return (

      <div className="root">

        {isRegistering ? (<Overlay noClorian={false} loading={true}/>) : (

          <div id="register" className="register-box">

            <div className="header-login">
              {clorianLogo && <img src={clorianLogo} alt="logo Clorian"/> }
              <h3 className="affWebRegistration">Affiliate Web Registration</h3>
            </div>

            {error && <p className="text-danger">{error}</p>}

            <form onSubmit={e => this.handleSubmit(e)}>
              <div className="form-group">
                <div className="input-group">
                <span className="input-group-addon" id="username">
                  <span className="glyphicon glyphicon-user"/>
                </span>
                  <input
                    type="email"
                    className="form-control"
                    name="user"
                    id="user"
                    required
                    ref={user => (this.user = user)}
                  />
                  <label htmlFor="username">EMAIL</label>
                </div>
              </div>

              <div className="form-group">
                <div className="input-group">
                <span className="input-group-addon" id="password">
                  <span className="glyphicon glyphicon-asterisk"/>
                </span>
                  <input
                    type="password"
                    className="form-control"
                    name="password"
                    id="password"
                    required
                    ref={pass => (this.pass = pass)}
                    onFocus={this.handlePasswordFocus}
                    onChange={this.handlePasswordChange}
                  />
                  <label htmlFor="password">PASSWORD</label>
                </div>
                {passwordError && <p className="validation-error">{passwordError}</p>}
              </div>

              <div className="form-group">
                <div className="input-group">
                <span className="input-group-addon" id="firstName">
                  <span className="glyphicon glyphicon-user"/>
                </span>
                  <input
                    type="text"
                    className="form-control"
                    name="firstName"
                    id="firstName"
                    required
                    ref={firstName => (this.firstName = firstName)}
                    onChange={this.handleFirstNameChange}
                  />
                  <label htmlFor="firstName">FIRST NAME</label>
                </div>
                {firstNameError && <p className="validation-error">{firstNameError}</p>}
              </div>

              <div className="form-group">
                <div className="input-group">
                <span className="input-group-addon" id="lastName">
                  <span className="glyphicon glyphicon-user"/>
                </span>
                  <input
                    type="text"
                    className="form-control"
                    name="lastName"
                    id="lastName"
                    required
                    ref={lastName => (this.lastName = lastName)}
                    onChange={this.handleLastNameChange}
                  />
                  <label htmlFor="password">LAST NAME</label>
                </div>
                {lastNameError && <p className="validation-error">{lastNameError}</p>}
              </div>

              <button type="submit" value="Entrar" className="btn btn-login" disabled={!this.state.isPasswordValid}>
                REGISTER
              </button>

            </form>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {

  const { registerAppUser } = state;

  return {
    isRegistering: registerAppUser.isRegistering
  };
};

export default connect(mapStateToProps)(injectIntl(AppUserRegister));
